// Exports:
export const studioActions = {
  SET_SELECTED_NODE: 'SET_SELECTED_NODE'
};

export const setSelectedNode = (payload) => ({
  type: studioActions.SET_SELECTED_NODE,
  payload
});
